import { useEffect } from 'react';

type ThemeProps = {
  active?: boolean;
};

export const usePortoTheme = ({ active = false }: ThemeProps) => {
  useEffect(() => {
    const portoClass = 'porto-dark';
    const anchorageClass = 'anchorage-dark';
    const classToAdd = active ? portoClass : anchorageClass;
    const classToRemove = active ? anchorageClass : portoClass;

    document.documentElement.classList.remove(classToRemove);
    document.documentElement.classList.add(classToAdd);

    return () => {
      document.documentElement.classList.remove(classToAdd);
    };
  }, [active]);
};
